export const PRACTICE_BANDS = ["elementary", "middle", "high"] as const;

export type PracticeBand = (typeof PRACTICE_BANDS)[number];

export function isPracticeBand(value: unknown): value is PracticeBand {
  return (
    value === "elementary" || value === "middle" || value === "high"
  );
}

export function parsePracticeBand(value: unknown): PracticeBand | null {
  if (typeof value !== "string") return null;
  return isPracticeBand(value) ? value : null;
}

/**
 * School stage for a grade in the Israel map.
 * Kindergarten through grade 6 are elementary, 7–9 middle, 10–12 high.
 */
export function bandForGrade(grade: number): PracticeBand {
  if (grade <= 6) return "elementary";
  if (grade <= 9) return "middle";
  return "high";
}

/** The single stage that contains the whole span, or null when the span crosses a stage. */
export function bandForGradeSpan(
  gradeMin: number,
  gradeMax: number,
): PracticeBand | null {
  const start = bandForGrade(gradeMin);
  const end = bandForGrade(gradeMax);
  return start === end ? start : null;
}
